import React from 'react';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import { Upload, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
const style = {
    minHeight: '4rem',
    width: '100%',
    marginRight: '1.5rem',
    padding: '1rem',
    fontSize: '1rem',
    lineHeight: 'normal',
    color: 'rgba(0, 0, 0, 0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
export const PartSlot = ({ accept, newRecords, lastDroppedItem, onDrop, onDropNew, noFileContent }) => {
    const [{ isOver, canDrop }, drop] = useDrop(() => ({
        accept: [...accept, NativeTypes.FILE],
        drop: (item) => {
            if (item?.index >= 0) {
                onDrop(item);
            }
            else {
                if (item['files']?.length) {
                    onDropNew(item['files']);
                }
            }
            return null;
        },
        collect: monitor => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }), [newRecords]);
    const isActive = isOver && canDrop;
    const activeStyles = isActive
        ? {
            border: '1px #d92923 dashed',
        }
        : {
            border: '1px #d9d9d9 solid',
        };
    const defaultNoFile = (React.createElement(Upload, { showUploadList: false, beforeUpload: file => {
            onDropNew([file]);
            // Prevent Ant Design from POSTing — we handle the file ourselves
            return false;
        } },
        React.createElement(Button, { type: "default", icon: React.createElement(PlusOutlined, null), size: "small", block: true, className: "!flex !items-center !justify-center !gap-2 !h-auto !min-h-[32px] !py-1 sm:!py-2 !px-2 sm:!px-4" },
            React.createElement("span", { className: "text-center whitespace-normal sm:whitespace-nowrap text-xs sm:text-sm leading-tight" }, "Drop here or click to upload"))));
    return (React.createElement("div", { ref: drop, className: "part-slot", "data-drop-active": isActive, style: { ...style, ...activeStyles } }, lastDroppedItem ? (React.createElement("div", { title: 'Drag and Drop to reorder' }, lastDroppedItem)) : (React.createElement("div", { title: 'Drop a file here ', className: "part-slot-empty", style: {
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.24)',
        } }, noFileContent ?? defaultNoFile))));
};
